import { useState } from 'preact/hooks';
import { isNonEmptyString } from '@thesavingsgroup/utils/isNonEmptyString';
import styles from './Select.module.css';
import type { SelectProps } from './types/SelectProps';
import type { JSX } from 'react/jsx-runtime';

const Select = ({
  label,
  options,
  placeholder = '',
  className = '',
  trailingIcon,
  error = false,
  floatingLabel = false,
  onFocus,
  onBlur,
  ...props
}: SelectProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = isNonEmptyString(props.value);
  const isFloated = !floatingLabel || isFocused || hasValue;

  const handleFocus = (e: JSX.TargetedFocusEvent<HTMLSelectElement>) => {
    setIsFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e: JSX.TargetedFocusEvent<HTMLSelectElement>) => {
    setIsFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div
      className={`${styles.selectWrapper} ${error ? styles.errorWrapper : ''} ${floatingLabel ? styles.floatingLabelWrapper : ''} ${className}`}
    >
      <div className={`${styles.selectContainer}`}>
        <select
          className={styles.select}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...props}
        >
          {placeholder && (
            <option value="" hidden>
              {placeholder}
            </option>
          )}

          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className={styles.iconContainer}>
          {trailingIcon ? (
            <img src={trailingIcon} alt="icon" />
          ) : (
            <span className={styles.arrow}></span>
          )}
        </span>
      </div>
      {label && (
        <label
          className={`${styles.label} ${floatingLabel && isFloated ? styles.floated : ''}`}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Select;
